<template>
  <div class="vabLogo">
    <div class="logo">
      <img class="app-logo" src="https://static.zzbtool.com/static/xf/xf_logo2.png" />
      <span v-if="!collapsed" class="app-name">晓风分销</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    collapsed: Boolean
  }
}
</script>
<style lang='less' scoped>
  @import './index';
</style>